import { COMPANY_LOGO, COMPANY_NAME } from "@/assets/logo";

export const trAscii = (s) => String(s ?? "")
  .replace(/ı/g, "i").replace(/İ/g, "I").replace(/ğ/g, "g").replace(/Ğ/g, "G")
  .replace(/ş/g, "s").replace(/Ş/g, "S").replace(/ç/g, "c").replace(/Ç/g, "C")
  .replace(/ö/g, "o").replace(/Ö/g, "O").replace(/ü/g, "u").replace(/Ü/g, "U");

// Draws the company logo + name header on a jsPDF doc. Returns the Y offset below the header.
export function pdfHeader(doc) {
  try {
    // Logo is ~3.8:1 wide — keep aspect ratio so it isn't squished/distorted.
    doc.addImage(COMPANY_LOGO, "PNG", 14, 13, 40, 8);
  } catch (e) { /* logo optional */ }
  doc.setFontSize(13); doc.setTextColor(0);
  doc.text(trAscii(COMPANY_NAME), 58, 18);
  doc.setFontSize(9); doc.setTextColor(130);
  doc.text(trAscii("Rayem Takip - Makine/Arac Bakim, Stok & Zimmet"), 58, 24);
  doc.setDrawColor(220); doc.line(14, 30, 196, 30);
  doc.setTextColor(0);
  return 40;
}
